module.exports = __webpack_public_path__ + "static/img/gengduo.f2481801.png";